module.exports = __webpack_public_path__ + "img/htmllogo.9aded1b6.png";